"use client";

import { useBookingEngineContext } from "../cin_context/BookingEngineContext";
import React, { useEffect, useState, useMemo, useRef } from "react";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import axios from "axios";
import { createSignature } from "../../app/utilities/signature";

const styles = {
  input: {
    padding: "5px",
    fontSize: "12px",
    width: "250px",
  },
};

const DateRangePicker = ({ isDayUseEnabled = false }) => {
  const {
    setSelectedDates,
    selectedStartDate,
    selectedEndDate,
    selectedPropertyId,setIsDateChanged
  } = useBookingEngineContext();
  
  const oldBookingEngineProperties = [52676, 53383, 54638, 53537, 24046, 21604, 
    23394, 21758, 26634, 23795, 7205, 54547, 7840, 55899,  6460, 14387 , 16128 ,6468 ,6461 ,8534 ,10412 , 21923, 9267,9500,9192, 9270, 9271, 9269];

  //  const oldBookingEngineProperties = [52676, 53383, 54638, 53537, 24046, 21604, 
  //   23394, 21758, 26634, 23795, 7205, 54547, 7840, 55899,  6460, 14387 , 16128 ,6468 ,6461 ,8534 ,10412 , 21923, 22435, 22139, 21837, 21853, 22825, 24198, 22827, 53216, 52063, 51555, 21836, 26744, 54645, 52073, 21895, 21794, 21885, 22913, 21856, 23660, 21861, 21835, 23713, 21884, 55096, 23096, 21871, 21803, 21847, 21798, 54349, 55341, 22805, 54390, 9267,9500,9192, 9270, 9271, 9269];
  const pricesMapRef = useRef({});
  const pricesMapRef2 = useRef({});
  const loadingRef = useRef(true);
  const flatpickrRef = useRef(null);
  const [pricesReady, setPricesReady] = useState(false);
 const defaultDesabledDate = useRef(null);
 
const IST_OFFSET_MINUTES = 330;

const getShiftedDateForFlatpickr = (date = new Date()) => {
  const localOffset = date.getTimezoneOffset(); // in minutes
  const diffMinutes = IST_OFFSET_MINUTES + localOffset;
  return new Date(date.getTime() + diffMinutes * 60 * 1000);
};
const parseISTStringToDateForFlatpickr = (istDateStr) => {
  const [y, m, d] = istDateStr.split("-").map(Number);

  // Create date at NOON to avoid timezone shifts
  const date = new Date(y, m - 1, d);
  date.setHours(12, 0, 0, 0);

  return date;
};
const formatISTDate = (date) =>
  new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);

const currentDate = useMemo(() => {
  const d = getShiftedDateForFlatpickr(new Date());
  d.setHours(0, 0, 0, 0);
  return d;
}, []);


const sixMonthsLater = useMemo(() => {
  const d = new Date(currentDate);
  d.setMonth(d.getMonth() + 6);
  return d;
}, [currentDate]);


const fromDateEt = useMemo(
  () => formatISTDate(currentDate),
  [currentDate]
);

const toDateEt = useMemo(
  () => formatISTDate(sixMonthsLater),
  [sixMonthsLater]
);

const fromDate = useMemo(() => {
  const d = getShiftedDateForFlatpickr(new Date());
  d.setHours(0, 0, 0, 0);
  return d;
}, []);
  const formatDate = (date) => formatISTDate(date);

const formatDate2 = (input) => {
  if (!input) return "";

  let date;

  // Case 1: Already a Date object
  if (input instanceof Date) {
    if (isNaN(input.getTime())) return "";
    date = input;
  }
  // Case 2: yyyy-mm-dd string (API data)
  else if (typeof input === "string") {
    const [y, m, d] = input.split("-").map(Number);
    if (!y || !m || !d) return "";

    // Create UTC date, then interpret in IST via Intl
    date = new Date(Date.UTC(y, m - 1, d));
  }
  else {
    return "";
  }

  // Format in IST
  const parts = new Intl.DateTimeFormat("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).formatToParts(date);

  const day = parts.find(p => p.type === "day")?.value;
  const month = parts.find(p => p.type === "month")?.value;
  const year = parts.find(p => p.type === "year")?.value;

  if (!day || !month || !year) return "";

  return `${day}-${month}-${year}`;
};

const formatPretty = (date) => {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const year = d.getFullYear();
  const monthShort = d.toLocaleString("en-GB", { month: "short" }); // Jan, Feb, ..., Dec
  return `${day}-${monthShort}-${year}`; // 24-Dec-2025
};


   useEffect(() => {
     const fetchPrices = async () => {
       if (!selectedPropertyId) return;

       loadingRef.current = true;
       try {
         const timestamp = Date.now().toString();
         const secret = "ABDEFGHJKLMOPQRSTUVWXYZ123456789";
         const signature = await createSignature(
           JSON.stringify(selectedPropertyId),
           timestamp,
           secret
         );
         const body = {
      selectedPropertyId: selectedPropertyId,
      fromDate: fromDateEt,
      toDate: toDateEt,
      dayuse : isDayUseEnabled ? "Y": "N"
    };
        //  const response = await fetch(
        //    "https://cinbe.cinuniverse.com/api/cin-api/rate-et",
        //    {
        //      method: "POST",
        //      headers: {
        //        "Content-Type": "application/json",
        //        "x-timestamp": timestamp,
        //        "x-signature": signature,
        //      },            
        //      body: JSON.stringify(body),
        //    }
        //  );
        
         const response = await fetch(
           "https://paylater.cinuniverse.com/api/cin-api/rate-et-dayuse",
           {
             method: "POST",
             headers: {
               "Content-Type": "application/json",
               "x-timestamp": timestamp,
               "x-signature": signature,
             },            
             body: JSON.stringify(body),
           }
         );

         const data = await response?.json();
         const dayRate = data?.PropertyList?.[0]?.DayRate || {};
         const prices = {};
         const prices2 = {};
         for (const date in dayRate) {
           prices[date] = dayRate?.[date]?.Rate || 0;
           
           prices2[formatDate2(date)] = dayRate?.[date]?.Rate || 0;

         }
         pricesMapRef.current = prices;
         pricesMapRef2.current = prices2;
         const disabledDates = Object.entries(prices2)
    .filter(([date, price]) => price == "0" || price == 0 || price === "N/A") 
    .map(([date]) => date);
    defaultDesabledDate.current = disabledDates;
         setPricesReady(true);
       } catch (error) {
         console.error("Error fetching prices:", error);
       } finally {
         loadingRef.current = false;
         if (flatpickrRef?.current && flatpickrRef?.current != undefined && flatpickrRef?.current != null ) {
           flatpickrRef?.current?.redraw();
         }
       }
     };

     fetchPrices();
   }, [selectedPropertyId, fromDateEt, toDateEt]);

  useEffect(() => {
    const inputElement = document?.getElementById("dateRangePicker");
    if (!inputElement) return;
 const disabledDates = Object.entries(pricesMapRef2?.current)
    .filter(([date, price]) => price == "0" || price == "0" || price === "N/A") 
    .map(([date]) => date);
 const instance = flatpickr(inputElement, {
   mode: isDayUseEnabled ? "single" : "range",
   dateFormat: "d-m-Y",
   minDate: fromDate,
  showMonths: 1,
  fixedHeight: true,
  showOutsideDays: false,
  position: "auto",
//   disable: [
//   function (date) {
//     const formatted = formatDate2(date); // "dd-mm-yyyy"
//     const price = pricesMapRef2.current?.[formatted];
//     return price === "N/A" || price === "0" || price === 0;
//   },
// ],
 disable: [],
  // defaultDate:
  //   selectedStartDate && selectedEndDate
  //     ? [new Date(selectedStartDate), new Date(selectedEndDate)]
  //     : null,

defaultDate: (() => {
  if (!selectedStartDate) return null;

  const start = parseISTStringToDateForFlatpickr(selectedStartDate);

        if (isDayUseEnabled) return start;
  let end;
  if (selectedEndDate) {
    end = parseISTStringToDateForFlatpickr(selectedEndDate);
  } else {
    end = new Date(start);
    end.setDate(end.getDate() + 1);
  }

  if (end <= start) {
    end = new Date(start);
    end.setDate(end.getDate() + 1);
  }

  return [start, end];
})(),

   onChange: (selectedDates, dateStr, fp) => {
     if (selectedDates?.length === 1) {
   const startDate = selectedDates[0];
 // let nextDate = new Date(startDate);
  const formatted = formatDate2(startDate);
  const price = pricesMapRef2.current?.[formatted];

  // Prevent N/A or 0 as check-in
  if(
      !oldBookingEngineProperties.includes(
        parseInt(selectedPropertyId)
      )){
    if (!price || price === "N/A" || price === "0" || price === 0) {
    // Find the next available date with price > 0
    let found = false;
    for (let i = 1; i <= 30; i++) { // check next 30 days max
      startDate.setDate(startDate.getDate() + 1);
      const nextFormatted = formatDate2(startDate);
      const nextPrice = pricesMapRef2.current?.[nextFormatted];
      if (nextPrice && nextPrice !== "N/A" && nextPrice !== "0" && nextPrice !== 0) {
        found = true;
        break;
      }
    }

    if (found) {
      // Set minDate to next valid date (so user can select checkout from here)
      fp.set("minDate", startDate);
    }else {
      // No valid date found ahead — reset picker
      fp.clear();
    }
    return;
  }
}

  // Valid check-in date
  fp.set("minDate", startDate);
  
           if (isDayUseEnabled) {
             const checkOutDate = new Date(startDate);
             checkOutDate.setDate(checkOutDate.getDate() + 1);

             const startDateFormatted = formatISTDate(startDate);
             const endDateFormatted = formatISTDate(checkOutDate);

            setIsDateChanged(true);

            let priceSum = 0;
            const tempDate = new Date(startDate);
            while (tempDate <= checkOutDate) {
              const dateKey = formatDate(tempDate);
              if (pricesMapRef?.current?.[dateKey]) {
                priceSum += pricesMapRef?.current?.[dateKey];
              }
              tempDate.setDate(tempDate.getDate() + 1);
            }
 
             setSelectedDates(startDateFormatted, endDateFormatted, priceSum);
             fp.input.value = formatPretty(startDate);
           }
 }

     if (!isDayUseEnabled &&  selectedDates?.length === 2) {
       let [startDate, endDate] = selectedDates;

      // ✅ Same date → shift checkout +1 day
      if (startDate.toDateString() === endDate.toDateString()) {
        endDate = new Date(startDate);
        endDate.setDate(endDate.getDate() + 1);
        fp.setDate([startDate, endDate], true);
      }

      // const startDateFormatted = formatDate(startDate);
      // const endDateFormatted = formatDate(endDate);

const startDateFormatted = formatISTDate(startDate);
const endDateFormatted = formatISTDate(endDate);
      setIsDateChanged(true);

      let priceSum = 0;
      const tempDate = new Date(startDate);
      while (tempDate <= endDate) {
        const dateKey = formatDate(tempDate);
        if (pricesMapRef?.current?.[dateKey]) {
          priceSum += pricesMapRef?.current?.[dateKey];
        }
        tempDate.setDate(tempDate.getDate() + 1);
      }

       setSelectedDates(startDateFormatted, endDateFormatted, priceSum);
     }

     if (!isDayUseEnabled && selectedDates?.length === 2) {
       const [startDate, endDate] = selectedDates;
       const pretty = `${formatPretty(startDate)} to ${formatPretty(endDate)}`;
       fp.input.value = pretty; // overwrite visible value with 24-Dec-2025 style
     }
 
   },

   onClose: (selectedDates, dateStr, fp) => {
        if (isDayUseEnabled) return;
    if (selectedDates?.length === 1) {
      // ✅ Case 1: User closed after only check-in → auto set checkout = next day
      const startDate = selectedDates?.[0];
      const checkOutDate = new Date(startDate);
      checkOutDate.setDate(checkOutDate?.getDate() + 1);

      fp.setDate([startDate, checkOutDate], true);

      const startDateFormatted = formatDate(startDate);
      const endDateFormatted = formatDate(checkOutDate);

      setIsDateChanged(true);

      let priceSum = 0;
      const tempDate = new Date(startDate);
      while (tempDate <= checkOutDate) {
        const dateKey = formatDate(tempDate);
        if (pricesMapRef?.current?.[dateKey]) {
          priceSum += pricesMapRef?.current?.[dateKey];
        }
        tempDate.setDate(tempDate?.getDate() + 1);
      }

      setSelectedDates(startDateFormatted, endDateFormatted, priceSum);
    }
  },
  
      onDayCreate: (dObj, dStr, fp, dayElem) => {
        if (!dayElem?.dateObj) return;

        const date = formatDate(dayElem?.dateObj);
        const priceTag = document?.createElement("div");
        priceTag.className = "flatpickr-price";
        priceTag.style.fontSize = "10px";
        priceTag.style.position = "absolute";
        priceTag.style.bottom = "8px";
        priceTag.style.left = "50%";
        priceTag.style.transform = "translateX(-50%)";

        if (loadingRef?.current) {
          priceTag.innerHTML = `<div class="skeleton-loader"></div>`;
        } 
       else if (pricesMapRef?.current?.[date] == "0" || pricesMapRef?.current?.[date] === "N/A") {
        priceTag.innerHTML = `<span class="na-text">N/A</span>`;
        dayElem.style.opacity = "0.5"; // visually disabled but clickable
      }
      else if (pricesMapRef?.current?.[date] !== undefined) {
        if (pricesMapRef?.current?.[date] == "0" || pricesMapRef?.current?.[date] === "N/A") {
          priceTag.innerHTML = `<span class="na-text">N/A</span>`;
          dayElem.classList.add("flatpickr-disabled");
          dayElem.style.pointerEvents = "none";
        } else {
          priceTag.textContent = pricesMapRef?.current?.[date];
        }
      }

        dayElem.appendChild(priceTag);
      },
});

if (selectedStartDate) {
  const start = parseISTStringToDateForFlatpickr(selectedStartDate);
  if (isDayUseEnabled) {
    instance.input.value = formatPretty(start);
  } else if (selectedEndDate) {
    const end = parseISTStringToDateForFlatpickr(selectedEndDate);
    const pretty = `${formatPretty(start)} to ${formatPretty(end)}`;
    instance.input.value = pretty; // only UI text
  }
}

    flatpickrRef.current = instance;

    return () => {
      instance.destroy();
    };
  }, [selectedPropertyId,selectedStartDate, selectedEndDate, isDayUseEnabled]);

  return (
    <div style={styles.input} className="flatpicker-for-calender-date">
      <style>
  {`
    .skeleton-loader {
      width: 40px;
      height: 10px;
      background: linear-gradient(90deg, #eee 25%, #ddd 50%, #eee 75%);
      background-size: 200% 100%;
      animation: shimmer 1.5s linear infinite;
      border-radius: 4px;
    }
    @keyframes shimmer {
      0% { background-position: -200% 0; }
      100% { background-position: 200% 0; }
    }
    .na-text {
      color: red !important;
      font-weight: 600;
    }
  `}
</style>

      <input
        id="dateRangePicker"
        placeholder="Please Select Date"
        style={styles.input}
        className="form-control"
        autoComplete="off"
      />
    </div>
  );
};

export default DateRangePicker;
